module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjM1IiBoZWlnaHQ9IjM1IiByeD0iMTcuNSIgZmlsbD0iI0Y3MDAwMCIvPgo8cGF0aCBkPSJNMjQgMTdMMTMuNSAyMy4wNjIyTDEzLjUgMTAuOTM3OEwyNCAxN1oiIGZpbGw9IiNGN0Y3RjciLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/company/youtube.svg
// module id = Hm8P
// module chunks = 38